import { testimonials } from '@/mocks/brand';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
              <a href="#testimonials">用户心声</a>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
              数百万用户的选择与信赖，真实口碑见证品质
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {testimonials.map((t) => (
              <div key={t.id} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-primary-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4 line-clamp-5">"{t.content}"</p>
                <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                  <div className="w-9 h-9 rounded-full bg-primary-200 flex items-center justify-center overflow-hidden flex-shrink-0">
                    <span className="text-xs font-bold text-primary-700">{t.name.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">{t.name}</p>
                    <p className="text-xs text-foreground-500 whitespace-nowrap">{t.role} · {t.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}